import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_10'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_10',
  name: "Which of the following topics are included within the facility's written policies and procedures for health and safety?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'OCCUPATIONAL_HEALTH_AND_SAFETY_LAWS',
      text: 'Occupational health and safety laws',
      externalIds: [
        {
          id: 'ms-1--12-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'GENERAL_WORK_ENVIRONMENT_I_E_VENTILATION_CLEANLINESS_NOISE_ETC_',
      text: 'General work environment (i.e. ventilation, cleanliness, noise, etc.)',
      externalIds: [
        {
          id: 'ms-1--12-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'BUILDING_SAFETY',
      text: 'Building safety',
      externalIds: [
        {
          id: 'ms-1--12-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'POWERED_MOTOR_VEHICLES_PMV_PROCEDURES',
      text: 'Powered Motor Vehicles (PMV) procedures',
      externalIds: [
        {
          id: 'ms-1--12-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EMERGENCY_PREPAREDNESS',
      text: 'Emergency preparedness',
      externalIds: [
        {
          id: 'ms-1--12-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CHEMICALS_HAZARDOUS_SUBSTANCES',
      text: 'Chemicals/Hazardous substances',
      externalIds: [
        {
          id: 'ms-1--12-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NANOMATERIALS',
      text: 'Nanomaterials',
      externalIds: [
        {
          id: 'ms-1--12-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKER_PROTECTION_PERSONAL_PROTECTIVE_EQUIPMENT_MACHINERY_AND_E',
      text: 'Worker Protection (personal protective equipment, machinery and equipment etc. )',
      externalIds: [
        {
          id: 'ms-1--12-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PRESSURE_VESSELS_SAFETY',
      text: 'Pressure vessels safety',
      externalIds: [
        {
          id: 'ms-1--12-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MATERIALS_HANDLING_AND_STORAGE',
      text: 'Materials handling and storage',
      externalIds: [
        {
          id: 'ms-1--12-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ABOVE_GROUND_STORAGE_TANKS_UNDERGROUND_STORAGE_TANKS',
      text: 'Above Ground Storage Tanks & Underground Storage Tanks',
      externalIds: [
        {
          id: 'ms-1--12-11x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ELECTRICAL_SAFETY',
      text: 'Electrical safety',
      externalIds: [
        {
          id: 'ms-1--12-12x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FIRST_AID_MEDICAL',
      text: 'First aid/Medical',
      externalIds: [
        {
          id: 'ms-1--12-13x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'BLOODBORNE_PATHOGENS_PROCEDURES',
      text: 'Bloodborne pathogens procedures',
      externalIds: [
        {
          id: 'ms-1--12-14x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CONTRACTOR_SAFETY',
      text: 'Contractor safety',
      externalIds: [
        {
          id: 'ms-1--12-15x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DORMITORIES',
      text: 'Dormitories',
      externalIds: [
        {
          id: 'ms-1--12-16x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CANTEENS',
      text: 'Canteens',
      externalIds: [
        {
          id: 'ms-1--12-17x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CHILDCARE',
      text: 'Childcare',
      externalIds: [
        {
          id: 'ms-1--12-18x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'STANDARD_OPERATING_PROCEDURES_SOPS_FOR_HOW_TO_PERFORM_EACH_JOB_',
      text: 'Standard operating procedures (SOPs) for how to perform each job safely',
      externalIds: [
        {
          id: 'ms-1--12-19x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'STEPS_FOR_WORKERS_TO_RAISE_HEALTH_AND_SAFETY_CONCERNS',
      text: 'Steps for workers to raise health and safety concerns',
      externalIds: [
        {
          id: 'ms-1--12-20x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PROTECTION_AGAINST_RETALIATION_FOR_WORKERS_WHO_RAISE_HEALTH_AND',
      text: 'Protection against retaliation for workers who raise health and safety concerns',
      externalIds: [
        {
          id: 'ms-1--12-21x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-1--12-22x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-1--12-22f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'OCCUPATIONAL_HEALTH_AND_SAFETY_LAWS',
                'GENERAL_WORK_ENVIRONMENT_I_E_VENTILATION_CLEANLINESS_NOISE_ETC_',
                'BUILDING_SAFETY',
                'POWERED_MOTOR_VEHICLES_PMV_PROCEDURES',
                'EMERGENCY_PREPAREDNESS',
                'CHEMICALS_HAZARDOUS_SUBSTANCES',
                'NANOMATERIALS',
                'WORKER_PROTECTION_PERSONAL_PROTECTIVE_EQUIPMENT_MACHINERY_AND_E',
                'PRESSURE_VESSELS_SAFETY',
                'MATERIALS_HANDLING_AND_STORAGE',
                'ABOVE_GROUND_STORAGE_TANKS_UNDERGROUND_STORAGE_TANKS',
                'ELECTRICAL_SAFETY',
                'FIRST_AID_MEDICAL',
                'BLOODBORNE_PATHOGENS_PROCEDURES',
                'CONTRACTOR_SAFETY',
                'DORMITORIES',
                'CANTEENS',
                'CHILDCARE',
                'STANDARD_OPERATING_PROCEDURES_SOPS_FOR_HOW_TO_PERFORM_EACH_JOB_',
                'STEPS_FOR_WORKERS_TO_RAISE_HEALTH_AND_SAFETY_CONCERNS',
                'PROTECTION_AGAINST_RETALIATION_FOR_WORKERS_WHO_RAISE_HEALTH_AND',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-29',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 19810,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
